import { render, staticRenderFns } from "./Materials.vue?vue&type=template&id=4c3339cc"
import script from "./Materials.vue?vue&type=script&lang=js"
export * from "./Materials.vue?vue&type=script&lang=js"
import style0 from "./Materials.vue?vue&type=style&index=0&id=4c3339cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports